import loadable from '@loadable/component';

export const OrgDashboardViewInternshipPageLoadable = loadable(
  () => import('./OrgDashboardViewInternshipPage'),
  {
    resolveComponent: (module) => module.OrgDashboardViewInternshipPage,
  },
);
